<template>
  <div>
    <el-card>
      <div class="flex flex-align-center flex-justify-between">
        <div class="flex flex-align-center flex-wrap gap-10 flex-1">
          <div class="flex flex-align-center gap-10">
            <div class="keyLabel">关键字：</div>
            <el-input v-model.trim="keywords" style="width:250px" placeholder="推手手机号"></el-input>
          </div>
          <div class="flex flex-align-center gap-10">
            <div class="keyLabel">月份筛选：</div>
            <el-date-picker
              value-format="yyyy-MM"
              format="yyyy-MM"
              v-model="month"
              type="month"
              :clearable="false"
              placeholder="选择月">
            </el-date-picker>
          </div>
          <el-button type="primary" @click="handleCurrentChange(1)">查询</el-button>
          <buttonPermissions :datas="'agentTeamPerformanceExport'">
            <el-button @click="exportFile">导出</el-button>
          </buttonPermissions>
        </div>
        <el-popover placement="bottom-end" trigger="hover">
          <div class="flex flex-column gap-20" style="width:445px">
            <div class="flex flex-align-start">
              <li></li>
              <div>
                <span class="font-bold">团队业绩：</span> =推手个人销售业绩+推手团队所有下级销售业绩；订单支付成功后按订单实付金额(不含运费)计入；业绩核算剔除退款成功部分
              </div>
            </div>
            <div class="flex flex-align-start">
              <li></li>
              <div>
                每月15号结算上个月支付成功的订单业绩
              </div>
            </div>
          </div>
          <div slot="reference" class="font-14 color-606266">统计说明 <i class="el-icon-warning-outline"></i> </div>
        </el-popover>
      </div>
      <div class="margin-top-10">
        <el-table :data="tablelist" v-loading="tableloading">
          <el-table-column prop="" label="推手昵称">
            <template slot-scope="scope">
              <div class="ellipsis">
                {{scope.row.Name || scope.row.WxNickname}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Phone" label="手机号"></el-table-column>
          <el-table-column prop="" :label="result.PerformanceIsSettlement?'已结算团队业绩':'待结算团队业绩'">
            <template slot-scope="scope">
              <div>
                {{scope.row.TeamPerformanceMoney}}元
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align:right" class="margin-top-10" v-if="total">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import buttonPermissions from '@/components/buttonPermissions';
import {
  tianXianTeamPerformancelist
} from "@/api/sv3.0.0"
export default {
  components: {
    buttonPermissions
  },
  data () {
    return {
      keywords:'',
      month:'',
      tablelist:[],
      tableloading:false,
      currentPage:1,
      pageSize:20,
      total:0,
      result:{}
    }
  },
  mounted(){
    this.initTime()
    this.gettablelist()
  },
  methods: {
    initTime(){
      let date = new Date()
      let years = date.getFullYear()
      let month = date.getMonth()+1>9?(date.getMonth()+1):('0'+(date.getMonth()+1))
      this.month = [years,month].join('-')
    },
    handleSizeChange(e){
      this.currentPage = 1
      this.pageSize = e
      this.gettablelist()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.gettablelist()
    },
    async gettablelist(){
      try{
        this.tableloading = true
        let res = await tianXianTeamPerformancelist({
          Keywords:this.keywords,
          StartTime:this.month+'-01',
          Skip:(this.currentPage-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.TianXianTeamPerformanceDtos.Results
          this.total = res.Result.TianXianTeamPerformanceDtos.Total
          this.result = {
            PerformanceIsSettlement:res.Result.PerformanceIsSettlement
          }
        }
      }finally{
        this.tableloading = false
      }
    },
    exportFile(){
      let url = location.origin + '/pc/tianXianTeamPerformance/export'
      url += '?Keywords='+encodeURI(this.keywords)
      url += '&StartTime=' + (this.month+'-01')
      window.open(url)
    }
  }
}
</script>

<style lang='less' scoped>

</style>